const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

// Backend de Visum Oftalmologia corre en 8030 en desarrollo.
export const PATH = isLocal
    ? `http://${window.location.hostname}:8030`
    : `https://${window.location.hostname}/api`;

export const WS_PATH = isLocal
    ? `ws://${window.location.hostname}:8030`
    : `wss://${window.location.hostname}`;
